import { createServerFn } from "@tanstack/react-start"
import { parseExactHttpsOrigin } from "@/lib/invent-iframe-bridge"

export interface InventWidgetRuntimeConfig {
  portalOrigin: string
}

export function readInventWidgetRuntimeConfig(
  environment: Record<string, string | undefined>,
): InventWidgetRuntimeConfig | null {
  const portalOrigin = parseExactHttpsOrigin(environment.INVENT_PORTAL_ORIGIN)
  return portalOrigin ? { portalOrigin } : null
}

export const getInventWidgetRuntimeConfig = createServerFn({ method: "GET" }).handler(async () =>
  readInventWidgetRuntimeConfig(process.env),
)
